module.exports = __webpack_public_path__ + "static/media/play-stone-boss-2-active.1a5bae9d.png";